import styled from "styled-components";

const Div = styled.div`
  color: ${(props) => props.theme.iconColor};
`;

export default Div;
